import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Categorias } from '../../../_entities/geocerca/Categorias';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CategoriasService {

  constructor(private http:HttpClient) { }

  obtenerCategorias():Observable<Categorias[]>{
      return this.http.get<Categorias[]>(environment.API_SECURITY+'/api/Geocercas/ObtenerCategorias');
  }

  obtenerCategoriaId(id:number):Observable<Categorias>{
    return this.http.get<Categorias>(environment.API_SECURITY+'/api/Geocercas/ObtenerCategoria/'+id);
  }

  agregarCategoria(categoria){
    return this.http.post(environment.API_SECURITY+'/api/Geocercas/AgregarCategoria',categoria);
  }

  eliminarCategoria(id:number):Observable<Categorias>{
    return this.http.delete<Categorias>(environment.API_SECURITY+'/api/Geocercas/EliminarCategoria/'+id);
  }

  actualizarCategoria(categoria){
    return this.http.put(environment.API_SECURITY+'/api/Geocercas/ActualizarCategoria',categoria);
  }
}
